import LogCannon from '@ace-clublabs/log-cannon';
import axios from 'axios';
import StatusCode from 'status-code-enum';
import { ErrorType } from '../../shared/types';
import CookieHelper from '../../utils/cookieHelper';
import { GetAdyenSession, IGetAdyenSessionRequest } from '../contracts';
import { createAxiosConfig } from '../mockHelper';

export const GetAdyenSessionApi =
  (endpoint: string): GetAdyenSession =>
  async (manifestId: string, request?: IGetAdyenSessionRequest) => {
    try {
      const scenario = CookieHelper.getCookie('scenario');
      const config = createAxiosConfig(scenario, endpoint);
      const paymentTypeQuery = request?.paymentType ? `?paymentType=${encodeURIComponent(request.paymentType)}` : '';
      const response = await axios.get(`${endpoint}/${manifestId}${paymentTypeQuery}`, config);
      LogCannon.blast('GetAdyenSessionApi success');
      return Promise.resolve(response.data);
    } catch (error: any) {
      /*
        422 = Invalid manifest
        404 = manifest doesn't exist
      */
      if (error.response) {
        LogCannon.error('GetAdyenSessionApi error', { error: error.response.data?.message });
        if (error.response.status === StatusCode.ClientErrorNotFound) {
          return Promise.reject({
            message: 'Your payment session has expired. Please try again.',
            requestId: error.response.data?.requestId,
            type: ErrorType.SESSION_TIMEOUT,
          });
        } else if (error.response.status === StatusCode.ClientErrorUnprocessableEntity) {
          return Promise.reject({
            message: 'Invalid Adyen payment session. Please contact support.',
            requestId: error.response.data?.requestId,
            type: ErrorType.MANIFEST_ERROR,
          });
        } else {
          return Promise.reject({
            message: error.response.data?.message,
            requestId: error.response.data?.requestId,
            type: ErrorType.SYSTEM_ERROR,
          });
        }
      } else {
        LogCannon.error('GetAdyenSessionApi error', { error });
        return Promise.reject({
          message: error,
        });
      }
    }
  };
